module.exports = __webpack_public_path__ + "static/media/block_folyo_slogan_01.e9f48765.png";